export default "__VITE_ASSET__31048831__$_?nuxt_component=async__"